import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  NgForm,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormGroupDirective,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTab, MatTabGroup, MatTabHeader } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
import {
  ConfirmationTab,
  InternalTabTypes,
  LicenseTab,
  MailingAddressTab,
  PaymentTab,
  PhysicalAddressTab,
  QualificationTab,
  SignatureTab,
} from 'projects/admin/src/app/models/exemptionFilling';
import { YesNoModalComponent } from 'projects/admin/src/app/shared/yes-no-modal/yes-no-modal.component';
import { forkJoin, merge } from 'rxjs';
import { ConfirmModalComponent } from '../../shared/component/confirm-modal/confirm-modal.component';
import { WarningApplicationComponent } from '../../shared/component/warning-application/warning-application.component';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';
import { ExternalNotesComponent } from '../external-notes/external-notes.component';
// import { CommonService } from 'projects/admin/src/app/services/common.service';
//MTc%3D

@Component({
  selector: 'app-initial',
  templateUrl: './initial.component.html',
  styleUrls: ['./initial.component.scss'],
})
export class InitialComponent implements OnInit {
  form!: FormGroup;
  QualificationTab!: FormGroup;
  VerificationTab!: FormGroup;
  PhysicalAddressTab!: FormGroup;
  MailingAddressTab!: FormGroup;
  PysicalMailingSame!: FormControl;
  requestStatusTypeId!: FormControl;
  externalStatusTypeId!: FormControl;
  qualTypeCtrl!: FormControl;
  LicenseTab!: FormGroup;
  SignatureTab!: FormGroup;
  ConfirmationTab!: FormGroup;
  PaymentTab!: FormGroup;
  paymentAndUploadMode: any;
  data: any;
  isDynamicValidationAdded = false;
  qualificationTypes: DropdownItem[] = [];
  countyTypes: DropdownItem[] = [];
  countryTypes: DropdownItem[] = [];
  stateTypes: DropdownItem[] = [];
  cityTypes: DropdownItem[] = [];
  allCites: DropdownItem[] = [];
  paymentTypes: DropdownItem[] = [];
  requestStatusTypes: DropdownItem[] = [];
  externalStatusTypes: DropdownItem[] = [];
  requestTypes: DropdownItem[] = [];
  qualTypeForEntityControl = [
    'OFFICERCORP',
    'MEMBERLLC',
    'FAMILYOWNER',
    'PARTNERLLP',
    'RELSECTBUSINESSENT',
  ];
  selectedTab: InternalTabTypes = InternalTabTypes.QualificationTab;
  @ViewChild('tabs') tabs!: MatTabGroup;
  selectedIndex: number = 0;
  requestId: number = 0;
  isLoading = false;
  title = '';
  isCorrectQualification = false;
  isCorrection = true;
  verificationError = '';
  selectedTabHeader = '';
  standingStatus: any;
  qualTypeForEntityName = ['SOLEPROPRIETOR', 'RELSECTSOLEPROP'];
  tabCount = 9;
  isSosFailed = false;
  sosStanding: any;
  sosAttempt = 0;
  isRevenueValidated: any;
  isEntityInfoSubscribed = false;
  IsVerificationCorrection = false;
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: ActivatedRoute,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private commonService: ExternalCommonService,
    private routerService: Router
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log(this.tabs);
      this.tabs._handleClick = this.interceptTabChange.bind(this);
    });
  }

  private loadData() {
    this.loadTypesData();
    this.isLoading = true;
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
      reqTypes: this.commonService.getRequestTypes(),
      countyty: this.commonService.getCountyTypes(),
      cty: this.commonService.getCityTypes(),
      stats: this.commonService.getStateTypes(),
    }).subscribe(({ exemptionData, reqTypes, cty, countyty, stats }) => {
      console.log(history);
      this.requestTypes = reqTypes;
      this.countyTypes = countyty;
      this.allCites = cty;
      this.stateTypes = stats;
      this.populateFormData(exemptionData);
      this.isLoading = false;
    });
  }
  private populateFormData(res: any) {
    setTimeout(() => {
      this.data = res;
      this.form.patchValue(this.data);
      this.QualificationTab.patchValue(this.data);
      this.VerificationTab.patchValue(this.data);
      this.QualificationTab.controls['qualificationType'].patchValue(
        this.data.qualificationTypeId
      );
      this.VerificationTab.controls['qualificationType'].patchValue(
        this.data.qualificationTypeId
      );
      if (this.data?.contactEmail?.length > 0) {
        this.QualificationTab.controls['confirmEmail'].patchValue(
          this.data.contactEmail
        );
      }
      if (this.data?.contactEmail?.length > 0) {
        this.VerificationTab.controls['confirmEmail'].patchValue(
          this.data.contactEmail
        );
      }
      if (!this.IsVerificationCorrection) {
        this.VerificationTab.controls['birthDate'].patchValue('');
        this.VerificationTab.controls[
          'lastFourSocialSecurityNumber'
        ].patchValue('');
      }
      if (this.data?.physicalAddress) {
        this.PhysicalAddressTab.patchValue(this.data?.physicalAddress);
        this.PhysicalAddressTab.controls['id'].patchValue(this.data.id);
      }
      if (this.data?.mailingAddress) {
        this.MailingAddressTab.patchValue(this.data?.mailingAddress);
        this.MailingAddressTab.controls['id'].patchValue(this.data.id);
      }

      this.PhysicalAddressTab.controls['useAsMailingAddress'].patchValue(
        this.data.usesPhysicalAddressAsMailingAddress
      );
      this.ConfirmationTab.controls['waveRightToSue'].patchValue(
        this.data.waveRightsToSue
      );

      var tnState = this.stateTypes.filter((x) => x.abbrv == 'TN');
      console.log(tnState);
      if (tnState.length > 0) {
        var tnStateId = tnState[0].id;
        if (!this.PhysicalAddressTab.controls['stateId'].value) {
          this.PhysicalAddressTab.controls['stateId'].patchValue(tnStateId);
        }
        if (!this.MailingAddressTab.controls['stateId'].value) {
          this.MailingAddressTab.controls['stateId'].patchValue(tnStateId);
        }
      }
      if (!this.isDynamicValidationAdded) {
        this.AddLicenseTabDynamicValidators();
        this.AddQualitficationTabDynamicValidators();
        this.applyValidatorEntityName(this.data?.qualificationType?.code);
      }
      const licenseInfo = this.getLicenseData(res);
      this.LicenseTab.patchValue(licenseInfo);
      this.populateSignatureTabData(this.data);
      this.ConfirmationTab.patchValue(this.data);
      console.log('county ' + this.LicenseTab.controls['county'].value);
      this.filterCitiesforCounty(this.LicenseTab.controls['county'].value);
      let rq = this.requestTypes.filter(
        (x) => x.id == this.data.exemptionRequestTypeId
      );

      this.validateAllFormFields(this.form);
      this.SubScribeEntityInfo();
    });
  }

  populateSignatureTabData(data: any) {
    this.SignatureTab.controls['firstName'].patchValue(
      data?.signatureFirstName
    );
    this.SignatureTab.controls['firstName'].updateValueAndValidity();
    this.SignatureTab.controls['middleName'].patchValue(
      data?.signatureMiddleName
    );
    this.SignatureTab.controls['middleName'].updateValueAndValidity();
    this.SignatureTab.controls['lastName'].patchValue(data?.signatureLastName);
    this.SignatureTab.controls['lastName'].updateValueAndValidity();
    this.SignatureTab.controls['suffix'].patchValue(data?.signatureSuffix);
    this.SignatureTab.controls['suffix'].updateValueAndValidity();
    this.SignatureTab.controls['title'].patchValue(data?.signatureTitle);
    this.SignatureTab.controls['title'].updateValueAndValidity();
    this.SignatureTab.controls['iCertify'].patchValue(data?.signatureICertify);
    this.SignatureTab.controls['iCertify'].updateValueAndValidity();
  }

  showWarningMessage(message: any) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Warning',
        warning: true,
        message: `${message}`,
      },
      disableClose: true,
    });
    return dialogRef;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  onCancel() {
    let dialogRef = this.dialog.open(WarningApplicationComponent, {
      data: {
        title: 'Warning',
        message: `Your application has not been completed. Leaving the page will cancel your application and no data will be saved. \n Click Leave to leave the page \n Click OK to continue entering your application?`,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == 'cancel') {
        const ereqType = this.externalStatusTypes.find(
          (x: { code: string }) => x.code == 'EXTSUBCANCELLED'
        )?.id;
        this.exemptionFilingRequestService
          .updateExternalRequestStatus(this.requestId, ereqType)
          .subscribe((res) => {
            this.routerService.navigateByUrl('/search');
          });
      }
    });
  }
  tabChanged(event: any) {
    this.selectedTab = event.tab?.textLabel;
    this.selectedTabHeader = event.tab?.textLabel;
  }

  Continue() {
    this.setNextTabIndex();
  }

  saveAndContinue() {
    console.log('save and continue - ln 282');
    this.validateAndSave(true);
  }

  validateAndSave(continueNextTab: Boolean) {
    if (this.selectedTab == InternalTabTypes.VerificationTab) {
      if (!this.VerificationTab.valid) {
        this.VerificationTab.markAllAsTouched();
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.QualificationTab) {
      if (this.sosStanding == 2) {
        this.showWarningMessage(
          'A valid Entity Control # is required. Contact the Business Services division of the Secretary of State at 615-741-2286 for questions about business entity name, entity control number, or status.'
        );
        return;
      }
      if (this.isSosFailed) {
        const qType = this.QualificationTab.controls['qualificationType'].value;
        const entityCN =
          this.QualificationTab.controls['entityControlNumber'].value;
        const fein = this.QualificationTab.controls['fein'].value;
        this.isLoading = true;
        this.exemptionFilingRequestService
          .saveEntityInformation(this.requestId, entityCN, fein, qType)
          .subscribe(
            (res: any) => {
              this.sosAttempt++;
              this.handleRevenueResponse(res);
              this.handleSosResponse(res);
              if (this.sosStanding == 2) {
                this.showWarningMessage(
                  'A valid Entity Control # is required. Contact the Business Services division of the Secretary of State at 615-741-2286 for questions about business entity name, entity control number, or status.'
                );
                return;
              } else {
                this.saveTabsData(continueNextTab);
              }
              this.isLoading = false;
            },
            (error) => {
              this.isSosFailed = true;
              this.isLoading = false;
              if (!this.QualificationTab.valid) {
                return;
              } else {
                this.saveTabsData(continueNextTab);
              }
            }
          );
        return;
      }
      if (!this.QualificationTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.PhysicalAddressTab) {
      if (!this.PhysicalAddressTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.MailingAddressTab) {
      if (!this.MailingAddressTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.LicenseTab) {
      if (this.LicenseTab.controls['stateLicenseNumber'].value === undefined) {
        this.LicenseTab.patchValue({stateLicenseNumber: ''});
        this.LicenseTab.patchValue({hasActiveStateLicense: false});
      }
      if (!this.LicenseTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.ConfirmationTab) {
      if (!this.ConfirmationTab.valid) {
        this.dialog.open(ConfirmModalComponent, {
          data: {
            title: 'Warning',
            warning: true,
            message: `The Attestation checkboxes must be checked to continue.`,
          },
          disableClose: true,
        });
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.PaymentTab) {
      if (!this.PaymentTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.UploadTab) {
      if (
        this.paymentAndUploadMode == null ||
        this.paymentAndUploadMode == undefined
      ) {
        this.dialog.open(ConfirmModalComponent, {
          data: {
            title: 'Warning',
            warning: true,
            message: `You must select one of the select options before continuing.`,
          },
          disableClose: true,
        });
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.SignatureTab) {
      if (
        !this.SignatureTab.valid ||
        this.SignatureTab.controls['iCertify'].value == false
      ) {
        if (
          this.SignatureTab.controls['iCertify'].value == false ||
          this.SignatureTab.controls['iCertify'].value == 'false'
        ) {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Warning',
              warning: true,
              message: `You have not indicated "I Certify". \n Click OK to go back.`,
            },
            disableClose: true,
          });
        }
        return;
      }
    }
    this.saveTabsData(continueNextTab);
  }
  private refreshData() {
    this.isLoading = true;
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
    }).subscribe(({ exemptionData }) => {
      this.populateFormData(exemptionData);
      this.isLoading = false;
    });
  }

  private saveTabsData(continueNextTab: Boolean) {
    const errorMsg = 'Error occured while saving data.';
    this.isLoading = true;
    switch (this.selectedTab) {
      case InternalTabTypes.VerificationTab: {
        if (this.IsVerificationCorrection) {
          var vtabdata = this.VerificationTab.value;
          var qtabdata = this.QualificationTab.value;
          qtabdata.contactPhone = vtabdata?.contactPhone;
          qtabdata.contactPhoneExtension = vtabdata?.contactPhoneExtension;
          qtabdata.contactEmail = vtabdata?.contactEmail;
          this.exemptionFilingRequestService
            .saveQualificationTab(qtabdata)
            .subscribe(
              (res: any) => {
                this.isLoading = false;
                this.refreshData();
                console.log(res);
                if (continueNextTab) this.setNextTabIndex();
              },
              (error) => {
                this.isLoading = false;
                var errorMessage = error.error
                  .replace('Data has been saved.', '')
                  .replace('Warning -', '');
                this.showWarningMessage(errorMessage);
              }
            );
          return;
        }
        this.exemptionFilingRequestService
          .saveRequestCopyVerificationTab(this.VerificationTab.value)
          .subscribe(
            (res: any) => {
              if (res?.result) {
                this.isLoading = false;
                let dialogRef = this.dialog.open(YesNoModalComponent, {
                  data: {
                    title: 'Correcting Existing Exemption?',
                    message: `Will you be correcting the Qualification Type, Entity Control #, FEIN or the Business Name of Sole Proprietor?`,
                  },
                  disableClose: true,
                });
                dialogRef.afterClosed().subscribe((res) => {
                  console.log(res);
                  let dialogRef = this.dialog.open(ExternalNotesComponent, {
                    data: {
                      requestId: this.requestId,
                    },
                    disableClose: true,
                  });
                  if (res.data == 'yes') {
                    this.isCorrectQualification = true;
                    this.tabCount = 9;
                    this.selectedIndex = 1;
                    this.selectedTab = InternalTabTypes.QualificationTab;
                    if (
                      this.qualTypeForEntityControl.includes(
                        this.data?.qualificationType.code
                      )
                    ) {
                      this.addValidators(
                        'QualificationTab',
                        'entityControlNumber',
                        Validators.required
                      );
                    } else {
                      this.clearValidators(
                        'QualificationTab',
                        'entityControlNumber'
                      );
                    }
                  } else {
                    this.isCorrectQualification = false;
                    this.IsVerificationCorrection = true;
                    this.tabCount = 8;
                  }
                });
              } else {
                this.verificationError = res?.errorMessage;
              }
            },
            (error) => {
              this.isLoading = false;
              console.log(error);
            }
          );
        break;
      }
      case InternalTabTypes.QualificationTab: {
        var tabdata = this.QualificationTab.value as QualificationTab;
        this.sosAttempt = 2;
        this.exemptionFilingRequestService
          .saveQualificationTab(tabdata)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => {
              this.isLoading = false;
              var errorMessage = error.error
                .replace('Data has been saved.', '')
                .replace('Warning -', '');
              this.showWarningMessage(errorMessage);
            }
          );
        break;
      }
      case InternalTabTypes.PhysicalAddressTab: {
        var phyTab = this.PhysicalAddressTab.value as PhysicalAddressTab;
        console.log(phyTab);
        this.exemptionFilingRequestService
          .savePhysicalAddressTab(phyTab)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              // this.refreshData();
              console.log(res);
              if (
                res.uspsValidationResponse &&
                res.uspsValidationResponse?.infoUsps?.addressUpdated
              ) {
                this.populateNewAddress(res.uspsValidationResponse?.infoUsps);
                let newAddress =
                  res.uspsValidationResponse?.infoUsps?.address1 + '\n';
                if (res.uspsValidationResponse?.infoUsps?.address2) {
                  newAddress +=
                    res.uspsValidationResponse?.infoUsps?.address2 + '\n';
                }
                newAddress += `${res.uspsValidationResponse?.infoUsps?.city} ${res.uspsValidationResponse?.infoUsps?.state} ${res.uspsValidationResponse?.infoUsps?.zipCode}`;
                let dialogRef = this.dialog.open(ConfirmModalComponent, {
                  data: {
                    title: 'Address',
                    message: `We have corrected the address based on the USPS database. \n\n ${newAddress}\n\n If this is correct, click on Save & Continue. Otherwise correct the address before continue. `,
                  },
                  disableClose: true,
                });
                dialogRef.afterClosed().subscribe((res) => {
                  console.log(res);
                  // if (res.data == 'ok') {
                  //   if (continueNextTab) this.setNextTabIndex();
                  // }
                });
              } else {
                console.log('usps address check failed ' + continueNextTab);
                if (continueNextTab) this.setNextTabIndex();
              }
            },
            (error) => { this.isLoading = false;}
          );
        break;
      }
      case InternalTabTypes.MailingAddressTab: {
        var mailTab = this.MailingAddressTab.value as MailingAddressTab;
        this.exemptionFilingRequestService
          .saveMailingAddressTab(mailTab)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              // this.refreshData();
              console.log(res);
              if (
                res.uspsValidationResponse &&
                res.uspsValidationResponse?.infoUsps?.addressUpdated
              ) {
                this.populateNewMailingAddress(
                  res.uspsValidationResponse?.infoUsps
                );
                let newAddress =
                  res.uspsValidationResponse?.infoUsps?.address1 + '\n';
                if (res.uspsValidationResponse?.infoUsps?.address2) {
                  newAddress +=
                    res.uspsValidationResponse?.infoUsps?.address2 + '\n';
                }
                newAddress += `${res.uspsValidationResponse?.infoUsps?.city} ${res.uspsValidationResponse?.infoUsps?.state} ${res.uspsValidationResponse?.infoUsps?.zipCode}`;
                let dialogRef = this.dialog.open(ConfirmModalComponent, {
                  data: {
                    title: 'Address',
                    message: `We have corrected the address based on the USPS database. \n\n ${newAddress}\n\n If this is correct, click on Save & Continue. Otherwise correct the address before continue. `,
                  },
                  disableClose: true,
                });
                dialogRef.afterClosed().subscribe((res) => {
                  console.log(res);
                  // if (res.data == 'ok') {
                  //   if (continueNextTab) this.setNextTabIndex();
                  // }
                });
              } else {
                console.log('usps address check failed ' + continueNextTab);
                if (continueNextTab) this.setNextTabIndex();
              }
            },
            (error) => { this.isLoading = false;}
          );
        break;
      }
      case InternalTabTypes.LicenseTab: {
        var licTab = this.LicenseTab.value as LicenseTab;
        this.exemptionFilingRequestService.saveLicenseTab(licTab).subscribe(
          (res: any) => {
            this.isLoading = false;
            this.refreshData();
            console.log('ln 630 - ', res);
            if (continueNextTab) 
              this.setNextTabIndex();
          },
          (error) => { this.isLoading = false;}
        );

//        if ((this.LicenseTab.controls['stateLicenseNumber'].value == '' || null) &&
//              this.LicenseTab.controls['county'].value == 0 &&
//              this.LicenseTab.controls['city'].value == 1 &&
//              continueNextTab) {
//          this.setNextTabIndex(); 
//        }
        break;
      }
      case InternalTabTypes.UploadTab: {
        var licTab = this.LicenseTab.value as LicenseTab;
        this.exemptionFilingRequestService
          .saveUploadTab(this.requestId, this.paymentAndUploadMode)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => {
              this.isLoading = false;
              alert(
                'You must select one of the select options before continuing.'
              );
            }
          );
        break;
      }
      case InternalTabTypes.ConfirmationTab: {
        var confTab = this.ConfirmationTab.value as ConfirmationTab;
        this.exemptionFilingRequestService
          .saveConfirmationTab(confTab)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => { this.isLoading = false;}
          );
        break;
      }
      case InternalTabTypes.SignatureTab: {
        var sigTab = this.SignatureTab.value as SignatureTab;
        this.exemptionFilingRequestService.saveSignatureTab(sigTab).subscribe(
          (res: any) => {
            this.isLoading = false;
            this.refreshData();
            console.log(res);
            if (continueNextTab) this.setNextTabIndex();
          },
          (error) => { this.isLoading = false;}
        );
        break;
      }
    }
  }
  private setNextTabIndex() {
    const skipMailingTab =
      this.PhysicalAddressTab.controls['useAsMailingAddress'].value;
    if (
      this.selectedTab == InternalTabTypes.PhysicalAddressTab &&
      skipMailingTab
    ) {
      this.selectedIndex += 2;
    } else this.selectedIndex += 1;
  }

  previousStep() {
    const skipMailingTab =
      this.PhysicalAddressTab.controls['useAsMailingAddress'].value;
    if (this.selectedTab == InternalTabTypes.LicenseTab && skipMailingTab) {
      this.selectedIndex -= 2;
    } else {
      this.selectedIndex -= 1;
    }
  }

  populateNewAddress(infoUsps: any) {
    this.PhysicalAddressTab.controls['address1'].patchValue(infoUsps?.address1);
    this.PhysicalAddressTab.controls['address1'].updateValueAndValidity();
    this.PhysicalAddressTab.controls['address2'].patchValue(infoUsps?.address2);
    this.PhysicalAddressTab.controls['address2'].updateValueAndValidity();
    this.PhysicalAddressTab.controls['city'].patchValue(infoUsps?.city);
    this.PhysicalAddressTab.controls['city'].updateValueAndValidity();
    this.PhysicalAddressTab.controls['zipCode'].patchValue(infoUsps?.zipCode);
    this.PhysicalAddressTab.controls['zipCode'].updateValueAndValidity();
  }

  populateNewMailingAddress(infoUsps: any) {
    this.MailingAddressTab.controls['address1'].patchValue(infoUsps?.address1);
    this.MailingAddressTab.controls['address1'].updateValueAndValidity();
    this.MailingAddressTab.controls['address2'].patchValue(infoUsps?.address2);
    this.MailingAddressTab.controls['address2'].updateValueAndValidity();
    this.MailingAddressTab.controls['city'].patchValue(infoUsps?.city);
    this.MailingAddressTab.controls['city'].updateValueAndValidity();
    this.MailingAddressTab.controls['zipCode'].patchValue(infoUsps?.zipCode);
    this.MailingAddressTab.controls['zipCode'].updateValueAndValidity();
  }

  getLicenseData(data: any): any {
    if (this.isCorrection == true && data?.stateLicense?.licenseNumber != null) {
      return {
        hasActiveStateLicense: data?.cspLicenseId == null ? true : false,     
        stateLicenseNumber: data?.stateLicense?.licenseNumber,
        cspLicenseId: data?.cspLicenseId,
        stateLicenseExpirationDate: data?.stateLicense?.licenseExpirationDate,
        county: data?.countyLicense?.countyId,
        countyLicenseNumber: data?.countyLicense?.licenseNumber,
        countyLicenseExpirationDate: data?.countyLicense?.licenseExpirationDate,
        city: data?.cityLicense?.cityId,
        cityLicenseNumber: data?.cityLicense?.licenseNumber,
        cityLicenseExpirationDate: data?.cityLicense?.licenseExpirationDate,
        requestStatusTypeId: data?.requestStatusTypeId,
        externalStatusTypeId: data?.externalStatusTypeId,
        id: data?.id,
      } as LicenseTab;
    }
    else {
      return { 
        //hasActiveStateLicense: data?.cspLicenseId == null ? true : false,
        stateLicenseNumber: data?.stateLicense?.licenseNumber,
        cspLicenseId: data?.cspLicenseId,
        stateLicenseExpirationDate: data?.stateLicense?.licenseExpirationDate,
        county: data?.countyLicense?.countyId,
        countyLicenseNumber: data?.countyLicense?.licenseNumber,
        countyLicenseExpirationDate: data?.countyLicense?.licenseExpirationDate,
        city: data?.cityLicense?.cityId,
        cityLicenseNumber: data?.cityLicense?.licenseNumber,
        cityLicenseExpirationDate: data?.cityLicense?.licenseExpirationDate,
        requestStatusTypeId: data?.requestStatusTypeId,
        externalStatusTypeId: data?.externalStatusTypeId,
        id: data?.id,
      } as LicenseTab;
    }
  }
  
  private loadTypesData() {
    this.commonService.getQualificationTypes().subscribe((res) => {
      this.qualificationTypes = res;
    });
    this.commonService.getCountryTypes().subscribe((res) => {
      this.countryTypes = res;
    });

    this.commonService.getRequestStatusTypes().subscribe((res) => {
      this.requestStatusTypes = res;
    });
    this.commonService.getExternalStatusTypes().subscribe((res) => {
      this.externalStatusTypes = res;
    });
  }

  interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
    return false;
  }

  private AddQualitficationTabDynamicValidators() {
    this.QualificationTab.controls['qualificationType'].valueChanges.subscribe(
      (value) => {
        if (value >= 0) {
          let qual = this.qualificationTypes.filter((x: any) => x?.id == value);
          if (
            qual.length > 0 &&
            this.qualTypeForEntityName.includes(qual[0].code)
          ) {
            this.QualificationTab.controls['filingEntityName'].enable();
            this.addValidators(
              'QualificationTab',
              'filingEntityName',
              Validators.required
            );
          } else {
            this.clearValidators('QualificationTab', 'filingEntityName');
            this.QualificationTab.controls['filingEntityName'].disable();
          }
        }
      }
    );
  }

  private applyValidatorEntityName(qual: any) {}

  private AddLicenseTabDynamicValidators() {
    var nrCounty = this.getNotRequiredCounty().id;
    this.LicenseTab.controls['county'].valueChanges.subscribe(() => {
      this.filterCitiesforCounty(this.LicenseTab.controls['county'].value);
    });
    this.addCondtionalRequiredValidators(
      'LicenseTab',
      'county',
      ['countyLicenseNumber', 'countyLicenseExpirationDate'],
      nrCounty
    );

    this.addCondtionalRequiredValidators(
      'LicenseTab',
      'hasActiveStateLicense',
      ['stateLicenseNumber', 'stateLicenseExpirationDate'],
      false
    );

    var nrCty = this.getNotRequiredCity().id;
    this.addCondtionalRequiredValidators(
      'LicenseTab',
      'city',
      ['cityLicenseNumber', 'cityLicenseExpirationDate'],
      nrCty
    );
  }

  private addCondtionalRequiredValidators(
    tabName: string,
    fieldName: string,
    fields: string[],
    expectedvalue: any
  ) {
    console.log(`tab ${tabName} fname ${fieldName} ${expectedvalue}`);
    (this.form.controls[tabName] as FormGroup)?.controls[
      fieldName
    ].valueChanges.subscribe((value) => {
      console.log(
        `tab ${tabName} fname ${fieldName} ${expectedvalue} value ${value}`
      );

     if (value && value != expectedvalue) {
        fields.forEach((fname) => {
          this.addValidators(tabName, fname, Validators.required);
        });
      } else {
        fields.forEach((fname) => {
          this.clearValidators(tabName, fname);
        });
      }
    });
  }

  addValidators(tabName: string, fieldName: string, valdtrs: ValidatorFn) {
    let ctrl = (this.form.controls[tabName] as FormGroup)?.controls[
      fieldName
    ] as AbstractControl;
    ctrl.addValidators(valdtrs);
    ctrl.updateValueAndValidity();
  }

  clearValidators(tabName: string, fieldName: string) {
    let ctrl = (this.form.controls[tabName] as FormGroup)?.controls[fieldName];
    ctrl.clearValidators();
    ctrl.updateValueAndValidity();
  }

  private filterCitiesforCounty(value: any) {
    console.log(value);
    if (value != undefined || value != '') {
      this.cityTypes = this.allCites.filter((x: any) => x?.county.id == value);

      if (!this.cityTypes.some((x: any) => x?.name == 'Not Required')) {
        let notRequiredCity = this.allCites.filter(
          (x: any) => x?.name == 'Not Required'
        );
        if (notRequiredCity?.length > 0)
          this.cityTypes.unshift(notRequiredCity[0]);
      }
    }
  }

  getNotRequiredCounty() {
    let county = this.countyTypes.filter((x: any) => x?.name == 'Not Required');
    return county[0];
  }

  getNotRequiredCity() {
    let city = this.allCites.filter((x: any) => x?.name == 'Not Required');
    console.log(this.allCites);
    console.log(city);
    return city[0];
  }

  async ngOnInit(): Promise<void> {
    console.log(btoa('true'));
    console.log(atob(this.router.snapshot.params.id));
    this.requestId = +atob(this.router.snapshot.params.id);
    this.buildForm();
    const tmpData = await this.exemptionFilingRequestService
      .getExemptionFilingRequestDetail(this.requestId)
      .toPromise();
    console.log(tmpData?.exemptionRequestType?.code);
    if (tmpData?.exemptionRequestType?.code == 'CORRECTION') {
      this.isCorrection = true;
      this.selectedIndex = 0;
      this.selectedTab = InternalTabTypes.VerificationTab;
    } else {
      this.isCorrectQualification = true;
      this.isCorrection = false;
      this.selectedIndex = 0;
      this.tabCount = 8;
      this.selectedTab = InternalTabTypes.QualificationTab;
    }
    this.loadData();
    this.router.queryParams.subscribe((params) => {
      if (params?.ifpf) {
        this.selectedIndex = 7;
        this.selectedTab == InternalTabTypes.PaymentTab;
        this.selectedTabHeader = 'Payment';
        if (params.ifpf == btoa('true')) {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Warning',
              warning: true,
              message: `Online payment failed. \n Click Mail In button to print confirmation to send with your payment to the Bureau of Workers' Compensation. `,
            },
            disableClose: true,
          });
        }
      }
    });
  }

  SubScribeEntityInfo() {
    if (!this.isEntityInfoSubscribed) {
      this.QualificationTab.controls[
        'qualificationType'
      ].valueChanges.subscribe(() => this.GetEntityInfo(true));
      // this.QualificationTab.controls[
      //   'entityControlNumber'
      // ].valueChanges.subscribe(() => this.GetEntityInfo(false));
      // this.QualificationTab.controls['fein'].valueChanges.subscribe(() =>
      //   this.GetEntityInfo(false)
      // );
      this.isEntityInfoSubscribed = true;
    }
  }

  onEcnFocusOutEvent(event: any) {
    const qType = this.QualificationTab.controls['qualificationType'].value;
    const entityCN =
      this.QualificationTab.controls['entityControlNumber'].value;
    const fein = this.QualificationTab.controls['fein'].value;
    this.isLoading = true;
    if (entityCN.length == 0) return;
    this.exemptionFilingRequestService
      .saveEntityInformation(this.requestId, entityCN, fein, qType)
      .subscribe(
        (res: any) => {
          this.handleSosResponse(res);
          console.log(res);
          this.isLoading = false;
        },
        (error) => {
          this.isSosFailed = true;
          this.isLoading = false;
        }
      );
  }

  onFeinFocusOutEvent(event: any) {
    const qType = this.QualificationTab.controls['qualificationType'].value;
    const entityCN =
      this.QualificationTab.controls['entityControlNumber'].value;
    const fein = this.QualificationTab.controls['fein'].value;
    this.isLoading = true;
    this.exemptionFilingRequestService
      .saveEntityInformation(this.requestId, entityCN, fein, qType)
      .subscribe(
        (res: any) => {
          this.handleRevenueResponse(res);
          console.log(res);
          this.isLoading = false;
        },
        (error) => {
          this.isSosFailed = true;
          this.isLoading = false;
        }
      );
  }

  GetEntityInfo(isQualTypeChanged: boolean): void {
    // if (this.sosAttempt >= 2) {
    //   return;
    // }
    const qType = this.QualificationTab.controls['qualificationType'].value;
    const entityCN =
      this.QualificationTab.controls['entityControlNumber'].value;
    const fein = this.QualificationTab.controls['fein'].value;
    let qTypeCode = this.qualificationTypes.filter((x: any) => x?.id == qType);
    let isValid = false;
    // if (qTypeCode.length > 0 && qType != null) {
    //   if (this.qualTypeForEntityControl.includes(qTypeCode[0].code)) {
    //     if (
    //       entityCN != null &&
    //       entityCN.length == 9 &&
    //       fein != null &&
    //       fein.length == 9
    //     ) {
    //       isValid = true;
    //     }
    //   } else {
    //     if (fein != null && fein.length == 9) {
    //       isValid = true;
    //     }
    //   }
    // }

    // if (isValid) {
    //   this.isLoading = true;
    //   this.sosAttempt++;
    //   this.exemptionFilingRequestService
    //     .saveEntityInformation(this.requestId, entityCN, fein, qType)
    //     .subscribe(
    //       (res: any) => {
    //         this.handleRevenueResponse(res);
    //         this.handleSosResponse(res);
    //         console.log(res);
    //         this.isLoading = false;
    //       },
    //       (error) => {
    //         this.isSosFailed = true;
    //         this.isLoading = false;
    //       }
    //     );
    // }
    if (isQualTypeChanged) {
      if (this.qualTypeForEntityControl.includes(qTypeCode[0].code)) {
        this.addValidators(
          'QualificationTab',
          'entityControlNumber',
          Validators.required
        );
      } else {
        this.clearValidators('QualificationTab', 'entityControlNumber');
      }
    }
  }

  private handleRevenueResponse(res: any) {
    if (this.isRevenueValidated) {
      return;
    }
    this.standingStatus = res?.infoRevenueResponse?.infoRevenue?.standingStatus;
    if (this.standingStatus == 2) {
      this.showWarningMessage(
        'FEIN entered does not match with Revenue, please re-enter correct FEIN found on your IRS 147 C FEIN Letter'
      );
    }
    if (this.standingStatus == 0) {
      this.showWarningMessage(
        'The system was not able to obtain tax clearance from the Tennessee Department of Revenue for this business entity. \n You must upload or mail in a Tax Clearance Letter from the Department of Revenue to complete your exemption request application.'
      );
    }
    if (res?.infoRevenueResponse?.infoRevenue != null) {
      this.isRevenueValidated = true;
    }
  }

  private handleSosResponse(res: any) {
    if (res?.infoSosResponse?.infoSos == null) {
      this.isSosFailed = true;
    } else {
      this.isSosFailed = false;
      this.sosStanding = res?.infoSosResponse?.infoSos?.StandingStatus;
      var sosEntityName = res?.infoSosResponse?.infoSos?.entityName;
      var qualificationTypeMatchedEntityType =
        res?.qualificationTypeMatchedEntityType;
      if (this.sosStanding == 0) {
        this.showWarningMessage(
          'Business Entity is not active and in good standing with the Secretary of State. Contact the Business Services division of the Secretary of State at 615-741-2286 for questions about business entity name, entity control number, or status.'
        );
      }
      if (qualificationTypeMatchedEntityType) {
        this.showWarningMessage(
          'Qualification Type selected does not match. Please select the Qualification Type matching the Business Entity Type registered with the Secretary of State.'
        );
      }
      if (this.sosStanding == 1) {
        this.sosAttempt = 0;
      }
      if (this.sosStanding == 2 && this.sosAttempt == 1) {
        this.showWarningMessage(
          'Entity Control # does not match records on file with the Secretary of State, please enter the correct Entity Control #.'
        );
      }
      if (this.sosStanding == 2 && this.sosAttempt == 1) {
        this.showWarningMessage(
          'Entity Control # does not match records on file with the Secretary of State, please enter the correct Entity Control #.'
        );
      }
      if (this.sosStanding == 2 && this.sosAttempt > 1) {
        this.showWarningMessage(
          'A valid Entity Control # is required. Contact the Business Services division of the Secretary of State at 615-741-2286 for questions about business entity name, entity control number, or status.'
        );
      }
      console.log(sosEntityName, 'entityName');
      if (sosEntityName != null && sosEntityName.length > 0) {
        this.data.filingEntityName = sosEntityName;
        console.log(sosEntityName, 'entityName');
        this.QualificationTab.controls['filingEntityName'].patchValue(
          sosEntityName
        );
        this.QualificationTab.controls[
          'filingEntityName'
        ].updateValueAndValidity();
      }
    }
  }

  private buildForm() {
    this.CreateForms();

    this.form = this.fb.group({
      QualificationTab: this.QualificationTab,
      PhysicalAddressTab: this.PhysicalAddressTab,
      MailingAddressTab: this.MailingAddressTab,
      LicenseTab: this.LicenseTab,
      ConfirmationTab: this.ConfirmationTab,
      SignatureTab: this.SignatureTab,
      PaymentTab: this.PaymentTab,
    });
  }

  paymentAndUploadModeSelected(value: number) {
    this.paymentAndUploadMode = value;
  }

  checkEmailMatch(group: FormGroup) {
    let email = group.controls.contactEmail.value;
    let confirmEmail = group.controls.confirmEmail.value;
    return email === confirmEmail ? null : { notSame: true };
  }

  private CreateForms() {
    this.VerificationTab = this.fb.group({
      ExemptionFilingRequestId: [this.requestId],
      qualificationType: [''],
      entityControlNumber: [''],
      filingEntityName: [''],
      firstName: [''],
      middleName: [''],
      lastName: [''],
      nameSuffix: [''],
      birthDate: ['', Validators.required],
      lastFourSocialSecurityNumber: [
        '',
        [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      ],
      contactPhone: ['', Validators.required],
      contactPhoneExtension: ['', [Validators.maxLength(6)]],
      contactEmail: ['', [Validators.required, Validators.email]],
      confirmEmail: ['', [Validators.required, Validators.email]],
    });
    this.qualTypeCtrl = new FormControl('', [Validators.required]);
    this.QualificationTab = this.fb.group(
      {
        id: [this.requestId],
        qualificationType: ['', Validators.required],
        entityControlNumber: ['', Validators.required],
        filingEntityName: [''],
        fein: ['', Validators.required],
        firstName: ['', Validators.required],
        middleName: [''],
        lastName: ['', Validators.required],
        nameSuffix: [''],
        birthDate: ['', Validators.required],
        lastFourSocialSecurityNumber: [
          '',
          [Validators.minLength(4), Validators.maxLength(4), Validators.required],
        ],
        contactPhone: ['', Validators.required],
        contactPhoneExtension: ['', [Validators.maxLength(6)]],
        contactEmail: ['', [Validators.required, Validators.email]],
        confirmEmail: ['', [Validators.required, Validators.email]],
      },
      { validator: this.checkEmailMatch }
    ); ///^[0-9]{10,10}$/
    this.QualificationTab.controls['confirmEmail'].markAsDirty();
    this.PysicalMailingSame = new FormControl('');
    this.PhysicalAddressTab = this.fb.group({
      id: [this.requestId],
      addressTypeId: ['2'],
      address1: ['', Validators.required],
      address2: [''],
      address3: [''],
      city: ['', Validators.required],
      stateId: ['', Validators.required],
      zipCode: ['', Validators.required],
      countyId: [''],
      useAsMailingAddress: [''],
      validateAddress: [true],
    });
    this.MailingAddressTab = this.fb.group({
      id: [this.requestId],
      addressTypeId: ['1'],
      address1: ['', Validators.required],
      address2: [''],
      address3: [''],
      city: ['', Validators.required],
      stateId: ['', Validators.required],
      zipCode: ['', Validators.required],
      countyId: [''],
      validateAddress: [true],
    });
    this.LicenseTab = this.fb.group({
      id: [this.requestId],
      hasActiveStateLicense: [''],
      stateLicenseNumber: ['', Validators.pattern("\\d*")],
      stateLicenseExpirationDate: [''],
      cspLicense: [''],
      county: ['', Validators.required],
      countyLicenseNumber: [''],
      countyLicenseExpirationDate: [''],
      city: ['', Validators.required],
      cityLicenseNumber: [''],
      cityLicenseExpirationDate: [''],
    });
    this.SignatureTab = this.fb.group({
      id: [this.requestId],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      suffix: [''],
      title: [''],
      iCertify: ['', Validators.required],
    });
    this.ConfirmationTab = this.fb.group({
      id: [this.requestId],
      stillAffiliated: [''],
      attestToTCA: [''],
      waveRightToSue: [''],
      registeredApplicant: [''],
      doHaveInjury: [''],
      yesHaveInjury: [''],
      dontHaveInjury: [''],
    });
  }
}
